<template>
	<img v-if="advert.logo" :src="advert.logo" class="advert-card__logo" alt="Prohuman">
</template>

<script lang="ts">
import {defineComponent, PropType} from "vue";
import {AdvertListItemInterface} from "@WebApp/Views/AdvertListView/Interfaces/AdvertListItemInterface";

export default defineComponent({
	name: "AdvertLogoComponent",
	props: {
		advert: {
			type: Object as PropType<AdvertListItemInterface>,
			required: true,
		}
	},
});
</script>

<style scoped>

</style>
